export default __webpack_public_path__ + "static/media/features_heading.3d05dc16.png";